<template>
  <b-container fluid>
  <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
    <b-form  @submit.prevent="handleSubmit(register)" @reset.prevent="reset" >
    <b-row>
      <b-col lg="6" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="org_id"
                    slot-scope="{ valid, errors }"
                    >
                    <template v-slot:label>
                        {{$t('org_pro.organization')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-select
                      plain
                      v-model="circulate_notification.org_id"
                      :options="organizationtList"
                      id="org_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0" disabled>{{ $t('globalTrans.select') }}</b-form-select-option>
                      </template>
                    </b-form-select>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Notice Title (En)" vid="notice_title" rules="required">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="notice_title"
                    slot-scope="{ valid, errors }"
                  >
                    <template v-slot:label>
                        {{$t('notification.notice_title')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-input
                      id="notice_title"
                      v-model="circulate_notification.notice_title"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Notice Description (En)" vid="description" rules="required">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="description"
                    slot-scope="{ valid, errors }"
                  >
                   <template v-slot:label>
                        {{$t('notification.notice_description')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-textarea
                      id="description"
                      v-model="circulate_notification.description"
                      debounce="500"
                      rows="2"
                      max-rows="3"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-textarea>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Notice For" vid="notice_for" rules="required|min_value:1">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="notice_for"
                    slot-scope="{ valid, errors }"
                    >
                    <template v-slot:label>
                        {{$t('notification.notice_for')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-select
                      plain
                      v-model="circulate_notification.notice_for"
                      :options="noticeForList"
                      id="notice_for"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0" disabled>{{ $t('globalTrans.select') }}</b-form-select-option>
                      </template>
                    </b-form-select>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Office" vid="office_id" rules="required|min_value:1">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="office_id"
                    slot-scope="{ valid, errors }"
                    >
                    <template v-slot:label>
                        {{$t('org_pro.office')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-select
                      plain
                      v-model="circulate_notification.office_id"
                      :options="officeList"
                      id="office_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Designation" vid="designation_id" rules="required|min_value:1">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="designation_id"
                    slot-scope="{ valid, errors }"
                    >
                    <template v-slot:label>
                        {{$t('globalTrans.designation')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-select
                      plain
                      v-model="circulate_notification.designation_id"
                      :options="designationList"
                      id="designation_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="6" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationProvider name="Notification Type" vid="notification_type_id" rules="required|min_value:1">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="notification_type_id"
                    slot-scope="{ valid, errors }"
                    >
                    <template v-slot:label>
                        {{$t('notification.notification_type')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-select
                      plain
                      v-model="circulate_notification.notification_type_id"
                      :options="notificationTypes"
                      id="notification_type_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Notice Title (Bn)" vid="notice_title_bn" rules="required">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="notice_title_bn"
                    slot-scope="{ valid, errors }"
                  >
                    <template v-slot:label>
                        {{$t('notification.notice_title_bn')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-input
                      id="notice_title_bn"
                      v-model="circulate_notification.notice_title_bn"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Notice Description (Bn)" vid="description_bn" rules="required">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="description_bn"
                    slot-scope="{ valid, errors }"
                  >
                    <template v-slot:label>
                        {{$t('notification.notice_description_bn')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-textarea
                      id="description_bn"
                      v-model="circulate_notification.description_bn"
                      debounce="500"
                      rows="2"
                      max-rows="3"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-textarea>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Date" vid="notice_date" rules="required">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="notice_date"
                    slot-scope="{ valid, errors }"
                  >
                    <template v-slot:label>
                        {{$t('globalTrans.date')}} <span class="text-danger">*</span>
                    </template>
                    <flat-pickr class="form-control"
                        v-model="circulate_notification.notice_date"
                        placeholder="Select Date"
                        :state="errors[0] ? false : (valid ? true : null)"
                    ></flat-pickr>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Time" vid="notice_time" rules="required">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="notice_time"
                    slot-scope="{ valid, errors }"
                  >
                    <template v-slot:label>
                        {{$t('globalTrans.time')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-input
                      id="notice_time"
                      type="time"
                      v-model="circulate_notification.notice_time"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <div class="row">
                  <div class="col-sm-3"></div>
                  <div class="col text-right">
                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                    &nbsp;
                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-xl')">{{ $t('globalTrans.cancel') }}</b-button>
                  </div>
                </div>
                &nbsp;
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
          <!-- <b-button variant="danger" class="mr-1" type="reset" >{{$t('globalTrans.reset')}}</b-button> -->

    </b-row>
    </b-form>
  </ValidationObserver>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { commonServiceBaseUrl } from '../../../../../config/api_config'
import { circulateNoticeStore, circulateNoticeUpdate } from '../../api/routes'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    if (this.id) {
      const tmp = this.getcirculate_notificationData()
      // Object.freeze(tmp)
      this.circulate_notification = tmp
    }
    this.notificationTypeList()
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      circulate_notification: {
        org_id: 0,
        notification_type_id: 0,
        notice_title: '',
        notice_title_bn: '',
        description: '',
        description_bn: '',
        notice_for: 0,
        office_id: 0,
        designation_id: 0,
        notice_date: '',
        notice_time: ''
      },
      officeList: [],
      designationList: [],
      notificationTypes: [],
      menuList: []
    }
  },
  computed: {
    organizationtList: function () {
      const listObject = this.$store.state.orgList
      return listObject
    },
    noticeForList: function () {
      const listObject = this.$store.state.commonObj.noticeforList
      const tmpList = listObject.map((obj, index) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.id, text: obj.name_bn }
        } else {
          return { value: obj.id, text: obj.name }
        }
      })
      return tmpList
    }
  },
  watch: {
    'circulate_notification.org_id': function (newVal, oldVal) {
      this.officeList = this.getOfficeList(newVal)
    },
    'circulate_notification.office_id': function (newVal, oldVal) {
      this.designationList = this.getdesignationList(newVal)
    }
  },
  methods: {
    getcirculate_notificationData () {
      return this.$store.state.list.find(item => item.id === this.id)
    },
    async register () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadingState = { loading: false, listReload: false }

      if (this.circulate_notification.id) {
        result = await RestApi.putData(commonServiceBaseUrl, `${circulateNoticeUpdate}/${this.id}`, this.circulate_notification)
      } else {
        result = await RestApi.postData(commonServiceBaseUrl, circulateNoticeStore, this.circulate_notification)
      }

      loadingState.listReload = true

      this.$store.dispatch('mutateCommonProperties', loadingState)

      if (result.success) {
        this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })

        this.$bvModal.hide('modal-xl')
      } else {
        this.$refs.form.setErrors(result.errors)
      }
    },
    getOfficeList (orgId = null) {
      const officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
      if (orgId) {
        const officeData = officeList.filter(office => office.org_id === orgId)
        const tmpList = officeData.map((obj, index) => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
        return tmpList
      }
    },
    getdesignationList (officeId = null) {
      RestApi.getData(commonServiceBaseUrl, 'assign-designation/list', officeId).then(response => {
        if (response.success === true) {
          const designationData = response.data.data.filter(designation => designation.office_id === officeId)
          this.designationList = designationData.map((obj, index) => {
            if (this.$i18n.locale === 'bn') {
              return { value: obj.designation_id, text: obj.designation_bn }
            } else {
              return { value: obj.designation_id, text: obj.designation }
            }
          })
        }
      })
    },
    notificationTypeList () {
      const notificationTypeList = this.$store.state.commonObjCommonConfig.notificationTypeList
      this.notificationTypes = notificationTypeList.map((obj, index) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    }
  }
}
</script>
